import React from "react"
import Disqus from "disqus-react"
import CuteLoader from '../Utilities/CuteLoader';

function getUrl() {
  const production = process.env.NODE_ENV === 'production'
  return production ? 'https://andyschneider.ca' : 'http://localhost:3000'
}

class DisqusComments extends React.Component {
  render() {
    const { articleIsPending, articleData, articleError } = this.props;
    const disqusShortname = "andyschneider-ca"
    if (articleError !== '') {
      return <div className="tc center"><h1>!</h1></div>;
    }
    else if (articleIsPending || !articleData) {
      return <div><CuteLoader /></div>;
    }
    const disqusConfig = {
      url: getUrl() + '/page/' + articleData.Path,
      identifier: articleData.ID.toString(),
      title: articleData.Title
    }

    return (
      <div className="pt1 pa3 ph5-ns">
        <Disqus.DiscussionEmbed
          shortname={disqusShortname}
          config={disqusConfig}
        />
      </div>
    )
  }
}

export default DisqusComments;